import React from "react";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";
// import SelectApplicationsDialog from "customs/components/ScriptStep/SelectApplicationsDialog";
import DownloadGeneratedApplicationsDialog from "customs/components/ScriptStep/DownloadGeneratedApplicationsDialog";
import ConfirmDialog from "customs/components/ConfirmDialog";

class GenerateApplicationComponent extends React.Component {

    constructor (props) {
        super(props);
        this.state = {
            // selectApplicationModal: false,
            // selectApplicationModalMsg: this.props.step.step,
            downloadApplicationModal: false,
            downloadApplicationModalMsg: this.props.step.step,

            "confirmModal": false,
            "confirmModalTitle": "",
            "confirmModalMsg": "Are you sure?",
            "action": ""
        };
        this.handleSelectApplicationDialog = this.handleSelectApplicationDialog.bind(this);
        this.handleDownloadApplicationDialog = this.handleDownloadApplicationDialog.bind(this);
        this.allPreviousStepsCompleted = this.allPreviousStepsCompleted.bind(this);
    }

    handleSelectApplicationDialog(show) {
        // this.setState({selectApplicationModal: show});
        this.setState({
            "confirmModal": true,
            "confirmModalMsg": `Are you sure you want to continue?`,
            "confirmModalTitle": this.props.step.step,
            "action": "generate_application"
        });
    }

    handleConfirmClick () {
        this.setState({"confirmModal": false});
        if (this.state.action === "generate_application") {
            this.props.handleUpdateStep(
                this.props.step.id, this.props.step.client_script_id,
                {'form_data': {'generate' : 'applications'}},
                () => {}
            );
        }
    }

    handleDownloadApplicationDialog(show) {
        this.setState({downloadApplicationModal: show});
    }

    allPreviousStepsCompleted() {
        let allCompleted = true;
        Object.keys(this.props.checklist.steps).forEach((key) => {
            try {
                if (this.props.checklist.steps[key].action_type === 'export_webdosh_import' || this.props.checklist.steps[key].action_type === 'generate_invoice') {
                } else if (this.props.checklist.steps[key].action_type !== "generate_application" && this.props.checklist.steps[key].status !== 1) {
                    allCompleted = false;
                }
            } catch(e) {}
        });
        return allCompleted;
    }

    render () {
        let generated_files = [];
        if (this.props.step.status === 1 && Object.keys(this.props.step.data).length > 0 && this.props.step.data[0] !== 0) {
            Object.keys(this.props.step.data).forEach((key) => {
                let file = this.props.client_files.find((file) => {
                    return file.id === this.props.step.data[key]['client_file_id'];
                });
                if (file) {
                    generated_files.push(file);
                }
            });
        }
        return <div>
            <Button
                disabled={this.props.readOnly || !this.allPreviousStepsCompleted()}
                color="success"
                onClick={() => this.handleSelectApplicationDialog(true)}
            >
                Generate
            </Button>
            {
                this.props.step.status === 1 && generated_files.length > 0
                ? <Button
                    disabled={!(this.props.index > 0 ? this.props.checklist.steps[this.props.index - 1].status === 1 : true)}
                    color="primary"
                    onClick={() => this.handleDownloadApplicationDialog(true)}
                >
                    Show
                </Button>
                : ""
            }
            <ConfirmDialog
                confirmModal={this.state.confirmModal}
                confirmModalMsg={this.state.confirmModalMsg}
                confirmModalTitle={this.state.confirmModalTitle}
                onClose={() => this.setState({"confirmModal": false})}
                onYesClick={() => this.handleConfirmClick()}
            />
            {/* {
                this.state.selectApplicationModal
                    ? <SelectApplicationsDialog
                        acquirers={this.props.acquirers}
                        applications={this.props.applications}
                        application_schema={this.props.application_schema}
                        client_files={this.props.client_files}
                        computeApplicationProgress={this.props.computeApplicationProgress}
                        setUsersNotification={this.props.setUsersNotification}
                        refreshClientContactsTable={this.props.refreshClientContactsTable}
                        selectApplicationModal={this.state.selectApplicationModal}
                        selectApplicationModalMsg={this.state.selectApplicationModalMsg}
                        onClose={() => this.handleSelectApplicationDialog(false)}
                        id={this.props.step.id}
                        client_script_id={this.props.step.client_script_id}
                        handleUpdateStep={this.props.handleUpdateStep}
                    />
                    : ""
            } */}
            {
                this.state.downloadApplicationModal
                    ? <DownloadGeneratedApplicationsDialog
                        generated_files={generated_files}
                        handleDownloadFile={this.props.handleDownloadFile}
                        handleApplicationSignature={this.props.handleApplicationSignature}
                        downloadApplicationModal={this.state.downloadApplicationModal}
                        downloadApplicationModalMsg={this.state.downloadApplicationModalMsg}
                        onClose={() => this.handleDownloadApplicationDialog(false)}
                        readOnly={this.props.readOnly}
                        acquirers={this.props.acquirers}
                    />
                    : ""
            }
        </div>;
    }
}

const GenerateApplication = withStyles(extendedFormsStyle)(GenerateApplicationComponent);

export default GenerateApplication;
